import { render, staticRenderFns } from "./ProductTypeForm.vue?vue&type=template&id=2b9e0034&scoped=true&"
import script from "./ProductTypeForm.vue?vue&type=script&lang=js&"
export * from "./ProductTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductTypeForm.vue?vue&type=style&index=0&id=2b9e0034&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9e0034",
  null
  
)

export default component.exports